import PrestoPlayer from "./presto-player";
import { isHLS } from "@/player/util";

export default ({ config, selector }) => {
  // dynamically load hls module if we have an hls video
  if (config?.blockAttributes?.src && isHLS(config?.blockAttributes?.src)) {
    return import("./hls").then((module) => {
      const hls = module.default;
      return hls({ config, selector });
    });
  }

  return new Promise((resolve, reject) => {
    return resolve(new PrestoPlayer(selector, { ...config }));
  });
};
